import { BrowserRouter, useLocation } from "react-router-dom";
import { MaterialHeader } from "./components/MaterialHeader";
import { InstallPrompt } from "./components/InstallPrompt";
// import { AuthDebug } from "./components/AuthDebug";
import { UserAuthContextProvider } from "./UserAuth";
import { TextSizeProvider } from "./contexts/TextSizeContext";
import Router from "./Router";

function AppContent() {
  const location = useLocation();
  
  const hideMainHeader = [
    '/challenge',
    '/create_challenge',
    '/join-challenges',
    '/archived-challenges',
    '/settings',
    '/leaderboard',
    '/deck',
    '/create-deck',
    '/join-decks',
    '/archived-decks',
  ].includes(location.pathname);

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: 'var(--md-sys-color-background)',
      color: 'var(--md-sys-color-on-background)'
    }}>
      {!hideMainHeader && <MaterialHeader />}
      <Router />
      <InstallPrompt />
      {/* <AuthDebug /> */}
    </div>
  );
}

function App() {
  return (
    <UserAuthContextProvider>
      <TextSizeProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </TextSizeProvider>
    </UserAuthContextProvider>
  );
}

export default App;
